
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { isError } from "../../state/helpers/Error"
import { INTEGRATION_KEY } from "../../state/integration/Constants"

type PayoutsCount = {
	totalPayoutsCount: number
}

class PayoutService {

    static async getPayoutsCount(merchantID: string, integrationKey: INTEGRATION_KEY): Promise<PayoutsCount> {
        const res = await AppContext.getApiClient().get(`/${integrationKey}/merchants/${merchantID}/payouts-count`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PayoutsCount
    }

}

export default PayoutService


// WEBPACK FOOTER //
// ./src/payment-account/service/payoutService.ts